module.exports = __webpack_public_path__ + "static/img/Cale-Hooker.9ddf60b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cale-Hooker.jpg
// module id = x+HJ
// module chunks = 0